export default __webpack_public_path__ + "img/cFsMYeEa.17b04921.svg";